export const numberToCurrency = (price) => {
  price = parseFloat(price).toFixed(2);
  price = price.replace(/\D/g, "");
  price = price.replace(/(\d{1,2})$/, ",$1");
  price = price.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  price = price != "" ? "R$ " + price : "";

  return price;
};
